module.exports = "<span>{{name}}</span>"